var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.2119 8.81795L20.4993 12.1127C20.4732 14.1193 19.7518 15.9583 18.5649 17.3996L10.6758 9.68247C10.8811 9.41353 11.061 9.12416 11.2119 8.81795ZM9.60533 10.7336L17.5135 18.4695C16.0553 19.7134 14.1713 20.473 12.1105 20.4993L8.62974 11.3001C8.97633 11.1461 9.30315 10.9556 9.60533 10.7336ZM7.1797 11.7064L10.4539 20.3597C8.84968 20.0649 7.40306 19.3197 6.25 18.2601V11.7442C6.33285 11.7481 6.4162 11.75 6.50001 11.75C6.73034 11.75 6.9572 11.7352 7.1797 11.7064ZM3.5 12C3.5 13.627 3.95715 15.1473 4.75 16.4394V11.4511C4.33164 11.3032 3.93765 11.1039 3.5757 10.8607C3.52577 11.2334 3.5 11.6137 3.5 12ZM20.3632 10.4728L11.6748 7.39057C11.7242 7.10112 11.75 6.80359 11.75 6.50004C11.75 6.41604 11.7482 6.33268 11.7446 6.25H18.2601C19.3239 7.40758 20.0708 8.86104 20.3632 10.4728ZM16.4394 4.75H11.4619C11.3152 4.32854 11.1151 3.93517 10.8671 3.57484C11.2377 3.52548 11.6159 3.5 12 3.5C13.627 3.5 15.1473 3.95715 16.4394 4.75ZM9.25303 3.95367C6.7683 4.80171 4.8017 6.76832 3.95366 9.25305C4.62298 9.87259 5.51716 10.25 6.50001 10.25C8.57107 10.25 10.25 8.57111 10.25 6.50004C10.25 5.51739 9.87251 4.62294 9.25303 3.95367ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "url(#paint0_linear_4439_21951)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4439_21951",
    x1: 0,
    y1: 0,
    x2: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D54F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC47A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.43582f7ad5fab4f614a07b1f3db7b196.svg";
export { ForwardRef as ReactComponent };